module.exports = __webpack_public_path__ + "static/media/brazil.56b34d61.png";